export default __webpack_public_path__ + "static/media/food_Unlocked.cbac0959.png";